import { useApp } from "@/store/app";
import environment from "../environment";
import CrashReporter from "./CrashReporter";

export type Config = {
  cause: string;
  useLimiter?: boolean;
};

const restartLimit = 5;
const reset_timeout = 15 * 60 * 1000;
const key = environment.appMode + "-restart-instance";
const releaseKey = environment.appMode + "-restart-release";
const release = __APP_VERSION__ + (__IS_PRERELEASE__ ? "-pre" : "");
let isRestarting = false;
let currentRestartInstance = Number(localStorage.getItem(key) || 0);

// Counts from a different build are stale — production and pre-release share the same origin
if (localStorage.getItem(releaseKey) !== release) {
  currentRestartInstance = 0;
  localStorage.setItem(key, "0");
  localStorage.setItem(releaseKey, release);
}

const reportAndReload = (cause: string) => {
  CrashReporter.sendRestart(cause, currentRestartInstance).finally(() => window.location.reload());
};

const restartApp = ({ cause, useLimiter }: Config) => {
  if (!useLimiter) {
    localStorage.setItem(key, "0");
    reportAndReload(cause);
  } else if (!isRestarting) {
    if (currentRestartInstance >= restartLimit) {
      // Terminal for this session — further failures must not report the limit again
      isRestarting = true;
      currentRestartInstance = 0;
      localStorage.setItem(key, "0");
      CrashReporter.sendMessage(`App restart limit reached: ${cause}`);
      useApp.getState().setStatus("FAILURE");
    } else {
      isRestarting = true;
      currentRestartInstance++;
      localStorage.setItem(key, String(currentRestartInstance));
      reportAndReload(cause);
    }
  }
};

setTimeout(() => {
  currentRestartInstance = 0;
  localStorage.setItem(key, "0");
}, reset_timeout);

export default restartApp;
